<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 14:29:38
 * @FilePath: \jyrg-web\src\views\mobile\home\index.vue
 * @Description: 群侠传移动端 - 首页
-->

<template>

  <div class="main">
    <div class="base-map">
      <!-- 进入官网 -->
      <template>
        <div class="voucher-button"  @click="voucherMobileCenterarHandle">
          充值
        </div>
        <!-- 主播码 -->
        <!-- <div class="userInfo" @click="userInfoHandle(true)">主播登记</div> -->
     <!-- 测试充值 -->
     <div class="answer" @click="answerHandle(true)"></div>
 
        <div class="logo">
          <img src="../../../assets/image/mb/logo.png" alt="" />
        </div>
       <!-- 上传图片 -->
        
   
            <!-- 游戏预约 -->
      <!-- <div class="order" @click="goToOrder()"> </div> -->
       <!-- 测试充值 -->
   <!-- <div class="test-order" @click="testVoucherMobileCenterarHandle"></div> -->
      <!-- 宣传活动 -->
<!--         <div class="pubilicze" @click="pubiliczeHandle()"></div>-->
 
        <div class="download">
          <div class="download-button and">
            <a :href="urls.anxUrl" style="color: #3b2606"  @click="setDownload(1)">安卓下载</a>
            <!-- <a @click="message()">安卓下载</a> -->
          </div>
          <div class="download-button ios">
            <a :href="urls.iosUrl"  @click="setDownload(2)" >IOS下载</a>
            <!-- <a @click="message()">IOS下载</a> -->
          </div>
              <!-- 充值 -->
            <template>
              <VoucherIndexMobileCenter
                ref="VoucherIndexMobileCenter"
                width="30%"
                @voucherMobileCenterClose="voucherMobileCenterarHandle"
              ></VoucherIndexMobileCenter>
            </template>
             <!-- 充值 -->
             <!-- 测试充值 -->
            <template>
              <TestVoucherMobileCenter
                ref="TestVoucherMobileCenter"
                width="30%"
                @testVoucherMobileCenterClose="testVoucherMobileCenterarHandle"
              ></TestVoucherMobileCenter>
            </template>
             <!-- 测试充值 -->
                  <!-- 用户信息 -->
            <template>
              <UserInfoCenter
                ref="UserInfoCenter"
                width="30%"
                @userInfoClose="userInfoHandle"
                ></UserInfoCenter>
            </template>
                <!-- 问答 -->
            <template>
              <AnswerMobileCenter
                ref="AnswerMobileCenter"
                width="30%"
                @answerClose="answerHandle"
                ></AnswerMobileCenter>
            </template>
    <!-- 问答 -->
             <!-- <div   @click="voucherMobileCenterarHandle"> 充值</div> -->
    
        </div>
      </template>

      <div class="base-layout map1">
    
            <!-- 标签切换区域 -->
            <div class="tab-buttons">
              <button 
                v-for="btn in  $config.dataInfoList" 
                :key="btn.selectType" 
                @click="toggleTab(btn.selectType)" 
                :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
              >
                  <div  :class="'tab-title'+ btn.tab">{{ btn.name }}</div>
                      <img
                        :src="btn.backgroundImg"
                        alt=""
                        :class="'people-tab' + btn.tab"
                      />
        </button>
        </div>
        <img
          src="../../../assets/image/mb/title1.png"
          alt=""
          class="map-title"
        />
        <div class="news" v-if="currentTab === 'official' ">
          <div class="news-list" >
            <div class="tab">
              <ul>
                <li
                  :class="index == tabIndex ? 'tab-active' : 'tab-def'"
                  v-for="(item, index) in $config.tabList"
                  :key="item.id"
                  @click="tabClick(item, index,1)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="list-content">
              <ul>
                <li
                  v-for="item in newList.slice(0, 3)"
                  :key="item.id"
                  @click="redirectPage({ path: '公告资讯', ...item },1)"
                >
                  <div class="list-headline">
                    <span class="title">{{ item.title }}</span>
                    <span class="date">{{
                      $moment(item.createTime).format("YYYY-MM-DD")
                    }}</span>
                  </div>
                  <div class="list-detail">
                    {{ $utils.toText(item.content) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="swiper">
            <!-- 角标 -->
            <img
              src="../../../assets/image/pc/icon-newsSwiper.png"
              alt=""
              class="swiper-icon"
            />
            <swiper
              class="news-swiper"
              :options="newsSwiperOption"
              v-if="activityList.length"
            >
              <swiper-slide v-for="i in activityList" :key="i.id">
                <!-- <img :src="i.imgStr" @click="redirectPage(i)" /> -->
                <img :src="i.imgStr"/>
              </swiper-slide>
            </swiper>
            <div class="swiper-mes">{{ activitTitle }}</div>
            <div class="swiper-pagination-news"></div>
          </div>
        </div>
        <!-- 高爆 -->
        <div class="news" v-if="currentTab === 'highExplosive' ">
          <div class="news-list" >
            <div class="tab">
              <ul>
                <li
                  :class="index == tabIndex ? 'tab-active' : 'tab-def'"
                  v-for="(item, index) in $config.tabList"
                  :key="item.id"
                  @click="tabClick(item, index,2)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="list-content">
              <ul>
                <li
                  v-for="item in newList.slice(0, 3)"
                  :key="item.id"
                  @click="redirectPage({ path: '公告资讯', ...item}, 2)"
                >
                  <div class="list-headline">
                    <span class="title">{{ item.title }}</span>
                    <span class="date">{{
                      $moment(item.createTime).format("YYYY-MM-DD")
                    }}</span>
                  </div>
                  <div class="list-detail">
                    {{ $utils.toText(item.content) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="swiper">
            <!-- 角标 -->
            <img
              src="../../../assets/image/pc/icon-newsSwiper.png"
              alt=""
              class="swiper-icon"
            />
            <swiper
              class="news-swiper"
              :options="newsSwiperOption"
              v-if="activityList.length"
            >
              <swiper-slide v-for="i in activityList" :key="i.id">
                <!-- <img :src="i.imgStr" @click="redirectPage(i)" /> -->
                <img :src="i.imgStr"  />
              </swiper-slide>
            </swiper>
            <div class="swiper-mes">{{ activitTitle }}</div>
            <div class="swiper-pagination-news"></div>
          </div>
        </div>

        <!-- 测试服 -->
        <div class="news" v-if="currentTab === 'threeExplosive' ">
          <div class="news-list" >
            <div class="tab">
              <ul>
                <li
                  :class="index == tabIndex ? 'tab-active' : 'tab-def'"
                  v-for="(item, index) in $config.tabList"
                  :key="item.id"
                  @click="tabClick(item, index,3)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="list-content">
              <ul>
                <li
                  v-for="item in newList.slice(0, 3)"
                  :key="item.id"
                  @click="redirectPage({ path: '公告资讯', ...item}, 3)"
                >
                  <div class="list-headline">
                    <span class="title">{{ item.title }}</span>
                    <span class="date">{{
                      $moment(item.createTime).format("YYYY-MM-DD")
                    }}</span>
                  </div>
                  <div class="list-detail">
                    {{ $utils.toText(item.content) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="swiper">
            <!-- 角标 -->
            <img
              src="../../../assets/image/pc/icon-newsSwiper.png"
              alt=""
              class="swiper-icon"
            />
            <swiper
              class="news-swiper"
              :options="newsSwiperOption"
              v-if="activityList.length"
            >
              <swiper-slide v-for="i in activityList" :key="i.id">
                <img :src="i.imgStr"  />
              </swiper-slide>
            </swiper>
            <div class="swiper-mes">{{ activitTitle }}</div>
            <div class="swiper-pagination-news"></div>
          </div>
        </div>

      </div>

      <div class="base-layout map3">
        <img
          src="../../../assets/image/mb/title3.png"
          alt=""
          class="map-title"
        />
        <div class="data">

          <!-- <div class="data-tab">
            <div
              v-for="item in $config.dataInfoList.slice(0, 2)"
              :key="item.tab"
            >
              <div
                :class="dataTabItemClass(item.tab)"
                @click="dataTabClick(item)"
              >
              <div  :class="'tab-title'+ item.tab">{{ item.name }}</div>
                <img
                  :src="item.backgroundImg"
                  alt=""
                  :class="'people-tab' + item.tab"
                />
              </div>
            </div>
          </div> -->
               <!-- 标签切换区域 -->
               <!-- <div class="tab-buttons">
              <button 
                v-for="btn in  $config.dataInfoList" 
                :key="btn.selectType" 
                @click="toggleTab(btn.selectType)" 
                :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
              >
                  <div  :class="'tab-title'+ btn.tab">{{ btn.name }}</div>
                      <img
                        :src="btn.backgroundImg"
                        alt=""
                        :class="'people-tab' + btn.tab"
                      />
        </button>
        </div> -->
          <div class="data-list"  v-if="currentTab === 'official' ">
            <ul>
              <li
                v-for="item in dataList.slice(0, 6)"
                :key="item.id"
                @click="redirectPage({ path: '游戏资料', ...item },1)"
              >
                <div class="item">
                  <div class="title">
                    <div class="icon">{{ $config.tabName[tabType] }}</div>
                    <p class="detail">{{ item.title }}</p>
                  </div>
                  <div class="date">{{ item.date }}</div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 高爆 -->
          <div class="data-list"  v-if="currentTab === 'highExplosive' ">
            <ul>
              <li
                v-for="item in dataHighList.slice(0, 6)"
                :key="item.id"
                @click="redirectPage({ path: '游戏资料', ...item },2)"
              >
                <div class="item">
                  <div class="title">
                    <div class="icon">{{ $config.tabName[tabType] }}</div>
                    <p class="detail">{{ item.title }}</p>
                  </div>
                  <div class="date">{{ item.date }}</div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 测试服 -->
          <div class="data-list"  v-if="currentTab === 'threeExplosive' ">
            <ul>
              <li
                v-for="item in dataThreeList.slice(0, 6)"
                :key="item.id"
                @click="redirectPage({ path: '游戏资料', ...item },3)"
              >
                <div class="item">
                  <div class="title">
                    <div class="icon">{{ $config.tabName[tabType] }}</div>
                    <p class="detail">{{ item.title }}</p>
                  </div>
                  <div class="date">{{ item.date }}</div>
                </div>
              </li>
            </ul>
          </div>
          <p class="more" @click="goToInformation('游戏资料')">更多 ></p>
        </div>
      </div>
      <div class="base-layout map2">
        <img
          src="../../../assets/image/mb/order/title2-2.png"
          alt=""
          class="map-title"
        />
        <div class="map2-swiper">
          <swiper :options="gameSwiperOption" v-if="gameplayList.length">
            <swiper-slide
              class="map2-swiper-slide"
              v-for="i in gameplayList"
              :key="i.id"
            >
              <!-- @click="redirectPage(i)" -->
              <img :src="i.imgStr" />
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination-game"></div>
        </div>
      </div>
      <div class="base-layout map4">
        <img
          src="../../../assets/image/mb/title4.png"
          alt=""
          class="map-title"
        />
        <div class="media-tab">
          <ul>
            <li
              :class="
                index == mediaTabIndex ? 'mediaTab-active' : 'mediaTab-def'
              "
              v-for="(item, index) in $config.mediaTab"
              :key="item.id"
              @click="mediaTabHandle(item, index)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="media-content" v-if="mediaTabIndex == 0">
          <div class="video-inside">
            <video
              poster="../../../assets/video/poster.png"
              ref="videoPlayer"
              src="../../../assets/video/video-inside.mp4"
              muted
              controls
            ></video>
          </div>
          <!-- <div style="font-size:12px;width:200px;margin-left:22px">
            <p>敬请期待~</p>
          </div> -->
        </div>
        <div class="media-content" v-else v-loading="loading">
          <!-- <div class="imgtest"></div>
          <div class="imgtest"></div>
          <div class="imgtest"></div>
          <div class="imgtest"></div> -->
          <el-image
            class="myimage"
            style="width: 136px; height: 78px"
            v-for="(item, index) in mediaImageList.slice(0, pageSize)"
            :src="item.imgStr"
            :key="index"
            :preview-src-list="[mediaImageList[index].imgStr]"
          >
          </el-image>
        </div>
        <div class="test" v-if="mediaTabIndex != 0">
          <!--          hide-on-single-page -->
          <el-pagination
            background
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="pageTotel"
            layout="prev, pager, next"
            prev-text="<"
            next-text=">"
          ></el-pagination>
        </div>
      </div>
      <Footer></Footer>

      <!-- 悬浮框 -->
      <!-- <SuspenPopup></SuspenPopup> -->


    </div>

    <!-- 登录 -->
    <template>
      <LoginDialog
        v-if="loginShow"
        :show="loginShow"
        class="myLoginDialog"
        @close="loginDialogClose(false)"
      ></LoginDialog>
    </template>
 
   <template>
     <PubiliczeDialog
      ref="PubiliczeDialog"
      width="30%"
      @pubiliczeClose="pubiliczeHandle"
      ></PubiliczeDialog>
   </template> 
   <el-dialog :visible.sync="showVisible" append-to-body  >
      <div style="width: 100%; height: 60px; text-align: center;font-size: 24px;">暂未开放，敬请期待！</div>
   <div style=" margin-left:45%;">
     <el-button size="mini" @click="showVisible = false"
     >关闭</el-button
     >
   </div>
 </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
// 局部引入vue-awesome-swiper
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getToken } from "@/utils/auth";
import Footer from "../../../components/mobile/Footer/index.vue";
import LoginDialog from "../../../components/public/LoginDialog";
import PubiliczeDialog from "../../../components/public/PubiliczeDialog";//宣传活动弹框
import UserInfoCenter from "../../../components/public/UserInfoCenterMoblie";
//import SuspenPopup from "../../../components/public/Suspend/index.vue";//悬浮框
import VoucherIndexMobileCenter from "../../../components/public/VoucherIndexMobileCenter";
import TestVoucherMobileCenter from "../../../components/public/TestVoucherMobileCenter";
import AnswerMobileCenter from "../../../components/public/AnswerMobileCenter";
import webSite from "../../../api/webSite";
import webSiteHigh from "../../../api/webSiteHigh";
import webSiteThree from "../../../api/webSiteThree";
import orderApi from "@/api/orderApi";
export default {
  name: "Home",
  metaInfo: {
    title: "《群侠传》官方网站_Q版千年武侠手游_值得期待的江湖世界",
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },

  watch: {
    $route(to, from) {
      this.tabClick({ name: "最新" }, 0);
    },
  },
  components: { swiper, Footer, swiperSlide, LoginDialog ,VoucherIndexMobileCenter,TestVoucherMobileCenter,PubiliczeDialog,UserInfoCenter,AnswerMobileCenter},
  computed: {
    ...mapGetters({
      // gameplayList: "base/gameplayList",
      gameDataList: "base/gameDataList",
      articlesList: "base/articlesList",
      // activityList: "base/activityList",
      gameDataListP: "base/gameDataList",
      loginShow: "base/loginShow",
    }),

    gameFeatureSwiper() {
      return this.$refs.gameFeatureSwiper.swiper;
    },
    wallpaperList() {
      return JSON.parse(localStorage.getItem("store")).wallpaperList;
    },
    screenshotList() {
      return JSON.parse(localStorage.getItem("store")).screenshotList;
    },
  },
  // 组件路由守卫
  data() {
    return {
      loading: false,
      showVisible:false,
      // pubiliczeShow:false,
      orderNum:0,
      activitTitle:'',
      url: "",
      tabType: 1,
      tabName: "",
      tabIndex: "",
      pageSize: 4,
      pageTotel: 0,
      currentPage: 1,
      mediaTabIndex: 1,
      bdVidVue:'',//推广百度参数
      currentTab: '',
      urls: {},
      newList: [],
      dataList: [],
      dataHighList:[],
      dataThreeList:[],
      gameplayList:[],
      activityList:[],
      selectedFile: null,
      newsSwiperOption: {
        effect: "fade",
        pagination: {
          el: ".swiper-pagination-news",
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false, //触摸后仍然执行
        },
      },
      gameSwiperOption: {
        loop: true,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination-game",
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false, //触摸后仍然执行
        },
      },

      mediaImageList: [],
      mediaImageListCopy: [],
    };
  },
 mounted() {
    this.getActivityImg(); // 公告咨询
    // await this.searchGameData(); // 江湖资料


    // try {
    //   await this.getAllNews(); // 全部文章
    // } catch (error) {
    //   console.info(error);
    // }
    this.dataTabClick(this.$config.dataTabList[0]);
    this.mediaTabHandle(null, 1);
    this.handleCurrentChange(1);
    this.getUrls(); // 下载地址
    
    this.getOrderNum();//获取预约人数
    this.setOcpcAccess();//添加百度访问信息
    this.gameplayListPro();
    this.toggleTab();
  },
  methods: {
    ...mapActions({
      // getAllNews: "base/getAllNews",
      getDownloadUrl: "base/getDownloadUrl",
      searchNewsById: "base/searchNewsById",
      searchGameData: "base/searchGameData",
    }),
    ...mapMutations({
      topUpDialog: "base/topUpDialog",
      loginDialog: "base/loginDialog",
    }),
        // 切换标签
       toggleTab(tab) {
      this.tabIndex=0
      if(tab != null && tab.trim() !== ''){
        sessionStorage.setItem('toggleTab', tab);
      }
      const storedValue = sessionStorage.getItem('toggleTab');

     if (tab === 'threeExplosive' || storedValue === 'threeExplosive' ) {
        this.currentTab="threeExplosive"
         this.dataTabClick(3)
         this.getActivityImg(3)
         this.getHeadTitles(3)
         this.tabClick({ name: "最新" }, 0,3)
      } else if (tab === 'highExplosive' || storedValue === 'highExplosive' ) {
        this.currentTab="highExplosive"
         this.dataTabClick(2)
         this.getActivityImg(2)
         this.getHeadTitles(2)
         this.tabClick({ name: "最新" }, 0,2)
      } else {
         this.currentTab="official"
         this.dataTabClick(1)
         this.getActivityImg(1)
         this.getHeadTitles(1)
         this.tabClick({ name: "最新" }, 0,1)
        // 其他 tab 的处理逻辑
      }

    },
    // 获取下载链接
    async getUrls() {
      const res = await this.getDownloadUrl(); // 下载地址
      this.url = this.$utils.isMobileType() == "ios" ? res.iosUrl : res.anxUrl;
      this.urls = res;
    },
    message() {
      alert("敬请期待！");
    },
     // 获取预约人数
    async getOrderNum() {
      try {
      const res0 = await webSite.getOrderNum();
      const res1 = await orderApi.getRealOrderNum();
      const orderNum = Number(res1.data.count) + Number(res0.data);
      this.orderNum=orderNum;
      } catch (error) {
        console.info(error);
      }
    },
  //下载添加点击事件计数
      async setDownload(type) {
        let osType;
        if(type==1){
          osType="ANDROID";
        }else if(type==2){
          osType="IOS";
        }else{
          osType="PC";
        }
        let res = await webSite.setDownload(osType,this.bdVidVue);
      },  
       //添加百度用户信息
       async setOcpcAccess() {
        let bdVid=this.$route.query.bd_vid;
        if(bdVid!=undefined){  
        if(bdVid){
          this.bdVidVue=bdVid;
          let params = {bdVid:bdVid};
          let res = await webSite.setOcpcAccess(params);
       }
    }
    },
    // 分页
    handleCurrentChange(val) {
      this.loading = true;
      setTimeout(() => {
        this.mediaImageList = this.mediaImageListCopy.slice(
          (val - 1) * this.pageSize,
          val * this.pageSize
        );
        this.loading = false;
      }, 500);
    },

    //充值界面
    voucherMobileCenterarHandle(state) {
      this.$refs.VoucherIndexMobileCenter.voucherMobileShow = state;
    },

    //测试充值
    testVoucherMobileCenterarHandle(state) {
      this.$refs.TestVoucherMobileCenter.testVoucherMobileShow = state;
    },
    userInfoHandle(state) {
      if (getToken()!=undefined) {
      this.$refs.UserInfoCenter.userInfoShow = true;
      }else{ 
        this.loginDialog(true);
      }
    },
    // 问答
    answerHandle(state) {
     
     this.$refs.AnswerMobileCenter.answerShow = true;
 
   },
    //
    async    mediaTabHandle(item, index) {
      let list = [];
      this.mediaTabIndex = index;
      this.currentPage = 1;
      switch (Number(index)) {
        case 1:{
            let gameType="精美壁纸"
         let res = await webSiteHigh.searchGameData(gameType);
           this.mediaSrcList = res.data[0].strategyEntity;
           list=  this.mediaSrcList
          break;
        }
        case 2:{
          
      let game="游戏截图"
      let resGame = await webSiteHigh.searchGameData(game);
       this.mediaImageList = resGame.data[0].strategyEntity;
       list=  this.mediaImageList
          break;
        }

         
        default:
        list = [];
          break;
      }
      this.mediaImageList = list;
      this.mediaImageListCopy = JSON.parse(JSON.stringify(list));
      this.pageTotel = this.mediaImageListCopy.length;
      this.currentPage = 1;
    },

    // tab - 资料
    // dataTabClick(item) {
    //   let { name, tab } = item;
    //   this.tabType = tab;
    //   this.tabName = name;
    //   let list = this.gameDataListP.find(
    //     (e) => e.strategyType == name
    //   ).strategyEntity;
    //   this.dataList = list;
    // },
        // tab - 资料
   async  dataTabClick(item) {
      if(item==3){
      let gameType="游戏介绍"
     let res = await webSiteThree.searchGameData(gameType);
       this.dataThreeList = res.data[0].strategyEntity;

      }else if(item==2){
      let gameType="游戏介绍"
      let res = await webSiteHigh.searchGameData(gameType);
       this.dataHighList = res.data[0].strategyEntity;

      }else{
      let gameType="游戏介绍"
     let res = await webSite.searchGameData(gameType);
       this.dataList = res.data[0].strategyEntity;

      }

    },
   // 获取活动标题
   async getHeadTitles(type) {
      try {
        if(type==3){
          let res = await webSiteThree.searchHeadTitles();
          this.activitTitle = res.data.titles;
        }else if(type==2){
          let res = await webSiteHigh.searchHeadTitles();
          this.activitTitle = res.data.titles;
        }else{
          let res = await webSite.searchHeadTitles();
          this.activitTitle = res.data.titles;
        }
     
      } catch (error) {
        console.info(error);
      }
    },
        //获取游戏特色
  async  gameplayListPro() {
          let newsType = "4";
          let res = await webSite.getAllNews(newsType);
          return this.gameplayList=res.data;
     },
   async  getActivityImg(type) {
      if(type==3){
        let res = await webSiteThree.getActivityImg();
        return this.activityList=res.data;
      }else if(type==2){
        let res = await webSiteHigh.getActivityImg();
        return this.activityList=res.data;
      }else{
        let res = await webSite.getActivityImg();
        return this.activityList=res.data;
      }

        },
    // class - 资料
    dataTabItemClass(type) {
      return this.tabType == type ? "item item-active" : "item item-def";
    },
    // tab - 公告
    async tabClick(item, index,wbtype) {
      const tab = item.name;
      const type = item.tab;
      // console.log(list)
      if(wbtype==3){
        this.tabIndex = index;
          switch (tab) {
            case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteThree.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
            case "更多":
              this.$router.push({
                path: "/newspaper",
                query: { title: "新闻资讯" },
              });
              break;
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteThree.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
          }
      }else if(wbtype==2){
        this.tabIndex = index;
          switch (tab) {
            case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteHigh.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
            case "更多":
              this.$router.push({
                path: "/newspaper",
                query: { title: "新闻资讯" },
              });
              break;
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteHigh.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
          }
      }else if(wbtype==1){
        this.tabIndex = index;
        switch (tab) {
            case "最新":{
              let newsType = "0,1,2";
                let res = await webSite.searchLatestNews(newsType);

                this.newList =res.data ;
                break;
              }
            case "更多":
              this.$router.push({
                path: "/newspaper",
                query: { title: "新闻资讯" },
              });
              break;
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSite.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
          }
      }
    },

    // 获取文章
    getNewsOftype(tab) {
      const type = tab.name;
      const list = JSON.parse(JSON.stringify(this.articlesList));
      if (type != "all") {
        this.newList = list.filter((e) => e.newsType == type);
      } else {
        this.newList = list;
      }
    },

    // 轮播 - 上下左右
    gameFeaturePrev() {
      this.gameFeatureSwiper.slidePrev();
    },
    gameFeatureNext() {
      this.gameFeatureSwiper.slideNext();
    },

    // goToInformation
    goToInformation(title) {
      this.$router.push({
        path: "/information",
        query: { path: title, title },
      });
    },

    // 跳转页面
    async redirectPage(item, type) { 
      let { id, path, title } = item;
      switch (title) {
        case "首页":
          this.$router.push({ path: "/" });
          break;
        case "游戏资料":
          this.goToInformation(title);
          break;
        case "联系客服":
          this.$router.push({ path: "/detail", query: { id, title, type } });
          break;
        case "无":
          break;
        default: {
     
          this.$router.push({
            path: "/detail",
            query: { id, title, path },
          });

          break;
        }
      }
    },

    // 充值
    topUp() {
      this.topUpDialog(true);
    },

    loginDialogClose(state) {
      this.loginDialog(state);
    },

    //宣传活动
    pubiliczeClose(state) {
      this.pubiliczeDialog(state);
    },

    // 前往预约
    pubiliczeHandle(state) {
      // this.$router.push({ path: "/order" });
      if (getToken()!=undefined) {
      this.$refs.PubiliczeDialog.pubiliczeShow = true;
      }else{
        this.loginDialog(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100vh;
  overflow: auto;
  z-index: 999;
  .base-map {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 375px;
    height: 2390.5px;
    background: url("../../../assets/image/mb/base-map1.png");
    background-size: 100% 100%;
    .base-layout {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .map-title {
      width: 206px;
      height: 23px;
    }
    //充值按钮
    .voucher-button{
      position: absolute;
      z-index: 999;
      width:65px;
      height:25px;
      right: 4%;
      top: 2%;
      font-size: 18px;
      color:#fff;
      text-align: center;
      line-height: 23px;
      font-family: "字体一";
      // background-color: #000;
      background: url("../../../assets/image/mb/order/upload/button-01.png") no-repeat
        center;
      background-size: 100% 100%;
      cursor: pointer;
    }
 


    // .order {
    //   // width: 173px;
    //   // height: 34px;
    //   // // 官网1.0 暂时隐藏
    //   // // background: url("../../../assets/image/mb/order/button-order.png");
    //   // background-size: 100% 100%;
    //   position: absolute;
    //   top: 14%;
    //   right: 18%;
    //   width: 24px;
    //   height: 130px;
    //   background: url("~@/assets/image/pc/order/button-goorder.png") no-repeat
    //     center;
    //   background-size: 100% 100%;
    //   cursor: pointer;
    // }
        //测试充值
        .userInfo{
          position: absolute;
          z-index: 999;
          width:80px;
          height:25px;
          right:25%;
          top: 2%;
          font-size: 18px;
          color:#fff;
          text-align: center;
          line-height: 23px;
          font-family: "字体一";
          visibility: visible;
          background: url("../../../assets/image/mb/order/upload/button-01.png") no-repeat
          center;
            background-size: 100% 100%;
          cursor: pointer;
 
      }
      //问答
      .answer{
          position: absolute;
          z-index: 999;
          width:80px;
          height:25px;
          right:25%;
          top: 2%;
          font-size: 18px;
          color:#fff;
          text-align: center;
          line-height: 23px;
          font-family: "字体一";
          visibility: visible;
          background: url("~@/assets/image/pc/answer.png") no-repeat
          center;
            background-size: 100% 100%;
          cursor: pointer;
 
      }
      //测试充值
      .test-order{
      position: absolute;
      top: 19%;
      left:26%;
      width: 180px;
      height:155px;
      background: url("~@/assets/image/pc/xmo.png") no-repeat
        center;
      background-size: 100% 100%;
      cursor: pointer;
    }

    //宣传活动
    .pubilicze{
      position: absolute;
      top: 23%;
      left: 33%;
      width: 130px;
      height:42px;
      background: url("~@/assets/image/pc/order/pubilicze-02.png") no-repeat
        center;
      background-size: 100% 100%;
      cursor: pointer;
    }
    
    .map1 {
      width: 375px;
      height: 475px;
      margin-top:30px;
      .tab-buttons {
      display: flex;
      gap:8px; /* 按钮之间的间距 */
      justify-content: center; /* 按钮居中显示 */
      margin-bottom: 25px;
      padding: 0 10px;
      // margin-bottom:1px;
    }

    .tab-button {
      /* 基础按钮样式，确保文字居中 */
      border: none;
      cursor: pointer;
      font-size: 13px;
      font-weight:400;
      color: #704c13;
      padding: 8px 12px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      transition: all 0.3s ease;
      outline: none;
      flex: 1;
      max-width: 110px;

      /* 移除默认按钮样式 */
      &:focus {
        outline: none;
      }
    }

    // 默认状态样式
    .item-def {
      background-image: url("../../../assets/image/pc/basemap-data-def.png");
      /* 根据实际图片尺寸调整按钮大小 */
      width: 100%;
      height: 50px;

    }

    // 激活状态样式
    .item-active {
      background-image: url("../../../assets/image/pc/basemap-data-active.png");
      color: #f4f7f6; /* 激活状态文字颜色 */

      width:100%;
      height: 50px;
    }
    .tab-title1{
      width: 100%;
      font-size: 13px;
      text-align: center;
    }
    .tab-title2{
        width: 100%;
        height: 20px;
        font-size: 13px;
        margin-left: -16px;
    }
    .tab-title3{
        width: 100%;
        height: 20px;
        font-size: 13px;
        // margin-left: -11px;
    }

    .tab-button .people-tab1 {
      width: 60px;
    height: 60px;
      position: relative;
      margin-left: -123%;
      margin-top: -70%;
    }

    .tab-button .people-tab2 {
      width:60px;
      height: 70px;
      position: relative;
      margin-top: -95%;
      margin-left: 52%;
    }
    .tab-button .people-tab3 {
      width: 85px;
    height: 85px;
      position: relative;
      margin-left: -123%;
      margin-top: -70%;
    }
      .news {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 20px;
        
        .swiper {
          position: relative;
          width: 320px;
          height: 181px;
          background: url("~@/assets/image/mb/basemap-news.png") no-repeat
            center;
          background-size: 100% 100%;
          margin-top: 30px;

          .news-swiper {
            margin: 16px 9px 0 9px;
            img {
              width: 303px;
              height: 140px;
            }
          }
          .swiper-icon {
            position: absolute;
            width: 18px;
            height: 43px;
            top: 3px;
            left: 12px;
            z-index: 2;
          }
          .swiper-mes {
            position: absolute;
            bottom: 10px;
            left: 20px;
            font-size: 9px;
            font-weight: 600;
            color: #7c441c;
          }
          .swiper-pagination-news {
            position: absolute;
            display: flex;
            align-items: flex-end;
            height: 10px;
            right: 30px;
            /deep/.swiper-pagination-bullet {
              width: 5px;
              height: 5px;
              opacity: 0.5;
              background: #fdf6eb;
              margin-bottom: -0.5;
              margin-left: 10px;
            }
            /deep/.swiper-pagination-bullet-active {
              width: 17px;
              height: 5px;
              border-radius: 40px;
              opacity: 1;
              background: #e3b553 !important;
            }
          }
        }
        .news-list {
          width: 320px;
          height: 208px;

          .tab {
            width: 100%;
            height: 36px;
            margin-bottom: 9px;
            ul {
              display: flex;
              align-items: center;
              width: 100%;
              height: 100%;
              li {
                width: 53px;
                height: 25px;
                font-size: 14px;
                line-height: 25px;
                text-align: center;
                margin: 0 3px;
                cursor: pointer;
              }
              .tab-def {
                color: #422405;
                background: url("~@/assets/image/mb/basemap-tab-def.png")
                  no-repeat center;
                background-size: 100% 100%;
              }
              .tab-active {
                color: #ed3434;
                background: url("~@/assets/image/mb/basemap-tab-active.png")
                  no-repeat center;
                background-size: 100% 100%;
              }
            }
          }
          .list-content {
            width: 320px;
            ul {
              width: 100%;
              height: 100%;
              li {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 12px;
                cursor: pointer;
                .list-headline {
                  display: flex;
                  justify-content: space-between;
                  color: #000;
                  .title {
                    width: 230px;
                    font-size: 14px;
                    margin-bottom: 3px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                  .date {
                    font-size: 14px;
                  }
                }
                .list-headline:hover {
                  color: #73511e;
                }
                .list-detail {
                  height: 26px;
                  font-size: 10px;
                  color: #6a6969;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }

    .map2 {
      width: 375px;
      height:250px;
      margin-top:27px;
      .map2-swiper {
        position: relative;
        width: 350px;
        height: 181px;
        margin-top: 29px;
        margin-left: 12px;
        .map2-swiper-slide {
          width: 350px;
          height: 181px;
          img {
            width: 339px;
            height: 170px;
          }
        }
        .swiper-pagination-game {
          position: absolute;
          display: flex;
          align-items: flex-end;
          right: 40%;
          bottom: -20px;
          /deep/.swiper-pagination-bullet {
            width: 10px;
            height: 10px;
            opacity: 1;
            background: transparent;
            margin-bottom: -0.5;
            margin-left: 20px;
            background: url("~@/assets/image/pc/pagination-bullet.png")
              no-repeat center;
            background-size: 100% 100%;
          }
          /deep/.swiper-pagination-bullet-active {
            width: 10px;
            height: 10px;
            border-radius: none;
            opacity: 1;
            background: url("~@/assets/image/pc/pagination-bullet-active.png")
              no-repeat center;
            background-size: 100% 100%;
          }
        }
      }
    }

    .map3 {
      margin-top:100px;
      width: 375px;
      height: 230px;
      // .data-tab {
      //   display: flex;
      //   justify-content: space-between;
      //   width: 328px;
      //   height: 71px;
      //   line-height: 71px;
      //   margin-top: 35px;
      //   font-size: 17px;
      //   font-weight: 600;
      //   .item:nth-child(1) { // 第一个标签项
      //   .people-tab1 {
      //     width: 100px;
      //     height: 105px;
      //     position: absolute;
      //     margin-top: -26%;
      //     margin-left: -6%;
      //     // 其他专属样式
      //   }
      // }
      

      //   .item {
      //     // position: relative;
      //     width: 152px;
      //     height: 71px;
      //     color: #704c13;
      //     cursor: pointer;

      //     .tab-title1{
      //     width:85%;
      //     line-height:70px;
      //     font-size: 16px;
      //     text-align: right;
      //   }
      //   .tab-title2{
      //     width:85%;
      //     text-indent:1em;
      //     line-height: 72px;
      //     font-size:16px;
      //     text-align: left;
      //   }
      //   .people-tab2 {
      //   width:92px;
      //   height: 105px;
      //   position: absolute;
      //   margin-top: -28%;
      //   margin-left: 22%;
      //   // 其他专属样式
      // }

      //     // img {
      //     //   position: absolute;
      //     //   width: 100%;
      //     //   height: 100%;
      //     //   right: 0;
      //     //   bottom: 4px;
      //     // }
      //   }
      //   .item-def {
      //     background: url("~@/assets/image/pc/basemap-data-def.png") no-repeat
      //       center;
      //     background-size: 100% 100%;
      //   }
      //   .item-active {
      //     width: 152px;
      //     height: 71px;
      //     color: #f4f7f6;
      //     background: url("~@/assets/image/pc/basemap-data-active.png")
      //       no-repeat center;
      //     background-size: 100% 100%;
      //   }
      //   p {
      //     margin-left: 20px;
      //   }
      // }

      .data-list {
        width: 328px;
        height: 162px;
        margin-top: 22px;
        ul {
          display: flex;
          justify-content: space-around;
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          li {
            display: flex;
            justify-content: center;
            width: 328px;
          }
        }
        .item {
          width: 328px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 26px;
          border-bottom: 2px solid #dbd2be;
          .title {
            display: flex;
            align-items: center;
            .icon {
              width: 45px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
              color: #714b15;
              background: url("~@/assets/image/pc/basemap-datalist-icon.png")
                no-repeat center;
              background-size: 100% 100%;
            }
            .detail {
              font-size: 14px;
              color: #6f4c10;
              margin-left: 15px;
            }
          }
          .date {
            font-size: 14px;
            color: #714b15;
          }
        }
      }
      .more {
        float: right;
        font-size: 14px;
        color: #714b15;
        margin-top: 10px;
      }
    }

    .map4 {
      width: 375px;
      height: 320px;
      margin-top:28px;
      .media-tab {
        width: 245px;
        height: 20px;
        font-size: 13px;
        border-bottom: 2px solid #a58e69;
        margin-top: 30px;
        ul {
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 100%;
          li {
            width: auto;
            height: 20px;
            line-height: 20px;
          }
          .mediaTab-active {
            color: #a77730;
          }
          .mediaTab-def {
            color: #6f4b12;
          }
        }
      }
      .media-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;
        width: 288px;
        height: 168px;
        margin-top: 30px;
        .video-inside {
          video {
            width: 100%;
            height: 100%;
          }
        }
      }

      .myimage {
        /deep/.el-image-viewer__wrapper {
          width: 136px;
          height: 78px;
          position: absolute;
          .el-image-viewer__canvas {
            position: absolute;
            height: 80%;
            top: 10%;
          }
        }
      }
      .media-img {
        width: 136px;
        height: 78px;
      }

      .test {
        margin-top: 14px;
        /deep/ .el-pagination button {
          min-width: 19px;
          height: 19px;
        }

        /deep/ .el-pagination span {
          min-width: 19px;
          height: 19px;
          font-size: 10px;
          line-height: 19px;
        }

        /deep/ .el-pagination .el-pager li {
          min-width: 19px;
          height: 19px;
          font-size: 10px;
          line-height: 19px;
        }

        /deep/ .el-pagination button:disabled {
          background: transparent;
          background-color: #e5e1d9;
          span {
            color: #643e22;
            font-weight: 700;
          }
        }
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #e8ce98;
        }
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
          background-color: #e5e1d9;
        }
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
          color: #643e22;
        }
      }
    }

    .go-home {
      position: absolute;
      top: 67px;
      right: 17px;
      width: 111px;
      height: 27px;
      background: url("../../../assets/image/mb/order/go-home.png");
      background-size: 100% 100%;
    }
    .logo {
      margin-top: 120px;
      height: 460px;
      img {
        width: 290px;
        height: 120px;
      }
    }

    .download {
      display: flex;
      justify-content: space-between;
      width: 240px;
      margin-top: 25px;
      .download-button {
        width: 106px;
        height: 27px;
        line-height: 25px;
        margin-top: 15px;
        cursor: pointer;
        a {
          font-size: 14px;
          padding-left: 40px;
          color: #fff;
        }
        p {
          font-size: 12px;
          padding-left: 40px;
          color: #fff;
        }
      }
      .and {
        color: #3b2606;
        background: url("~@/assets/image/mb/button-and.png") no-repeat center;
        background-size: 100% 100%;
      }
      .ios {
        background: url("~@/assets/image/mb/button-ios.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
    .supen-popup {
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 20rpx;
		box-sizing: border-box;
		background: white;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		border: 1px solid #aaa;
		font-size: 24rpx;
		width: 100%;
		height: 100%;
	}

  }

 
}

</style>
